import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { DialogActions, IconButton, SxProps, Theme } from "@mui/material";

import { CustomButton } from "../Button";
import { useResponsive } from "../../hooks/customUseResponsive";
import closeIconImage from '../../assets/images/closeIcon.svg';
import { CustomDialogProps } from "./Dialog.d";

interface TransitionProps {
  children: React.ReactElement;
  direction?: "left" | "right" | "up" | "down";
}

const Transition = React.forwardRef<unknown, TransitionProps>(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default React.memo(function CustomDialog({
  open,
  children,
  handleSubmit,
  handleClose,
  title,
  width,
  sx,
  buttonTxt,
  className = "",
  alignActions = "end",
  btnColor = "#1b3e61",
  fullWidth = false,
  disabled = false,
  cancelBtn = false,
  isLoading = false,
  showCrossIcon = true,
  crossIconFunc,
  cancelBtnTxt = "Cancel",
  onClose = true,
  isHeader = true,
  customHeaderComponent = "",
  bodyBackgroundColor = "#fff",
  headerBackgroundColor = "rgba(247, 249, 252, 1)",
  keepMounted = false,
  ...otherProps
}: CustomDialogProps) {
  const isMobile = useResponsive("down", "md");
  const defaultSx: SxProps<Theme> = {
    height: "90vh",
    "& .MuiPaper-root": {
      borderRadius: "8px",
      maxWidth: width ? width : "470px",
    },
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth={fullWidth}
        keepMounted={keepMounted}
        onClose={typeof onClose === 'function' ? onClose : (onClose ? handleClose : () => { })}
        onClick={(e) => e.stopPropagation()}
        aria-describedby="alert-dialog-slide-description"
        className={`form-dialog ${className}`}
        sx={sx || defaultSx}
        {...otherProps}
      >
        {isHeader && (
          <>
            <DialogTitle
              className="form-dialog-title"
              sx={{ backgroundColor: headerBackgroundColor }}
            >
              {title}
              {customHeaderComponent}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={crossIconFunc ? crossIconFunc : handleClose}
              className={
                showCrossIcon
                  ? "form-dialog-close-icon"
                  : "form-dialog-close-icon pointer-events-none"
              }
            >
              {showCrossIcon && <img src={closeIconImage} alt="close" />}
            </IconButton>{" "}
          </>
        )}
        <DialogContent
          className="form-dialog-content"
          sx={{ backgroundColor: bodyBackgroundColor }}
        >
          {children}
        </DialogContent>
        {(buttonTxt || cancelBtn) && (
          <DialogActions
            className="confirmation-dialogAction"
            sx={{
              justifyContent: alignActions,
              backgroundColor: bodyBackgroundColor,
            }}
          >
            {cancelBtn && (
              <CustomButton
                variant="outlined"
                onClick={handleClose}
                className={"confirmation-action-cancel-btn"}
              >
                {cancelBtnTxt}
              </CustomButton>
            )}
            {buttonTxt && (
              <CustomButton
                onClick={() => {
                  handleSubmit?.();
                }}
                disabled={disabled || isLoading}
                variant="contained"
                type="submit"
                sx={{
                  bgcolor: btnColor,
                  mr: cancelBtn ? "10px" : "0px",
                  fontSize: isMobile ? "14px" : "16px",
                  padding: isMobile ? "6px 18px" : "10px 16px",
                  minWidth: isMobile ? "" : "160px",
                }}
                className={"button-base button-compact confirmation-action-submit-btn"}
              >
                {buttonTxt}
              </CustomButton>
            )}
          </DialogActions>
        )}
      </Dialog>
    </React.Fragment>
  );
});
